module.exports = __webpack_public_path__ + "img/SkylineAugustLogos_Black.72c9bb94.svg";